function toIsoFromUtc(value) {
  if (!value) return null;
  if (typeof value !== 'string') return value;
  if (value.includes('T') || value.endsWith('Z')) return value;
  return `${value.replace(' ', 'T')}Z`;
}

export function normalizeAlertRecord(record) {
  const isObs = record.is_obs != null ? !!record.is_obs : !record.is_fx_alert;
  const obsTime = record.observation_time
    || record.observation_time_utc
    || record.observation_time_local
    || null;
  const sentTime = record.sent_time || record.time_sent || null;
  const alertText = record.alert_text && record.alert_text.length
    ? record.alert_text
    : (isObs ? 'Observation alert' : 'Forecast alert');

  return {
    ...record,
    alert_id: record.alert_id,
    spot_id: record.spot_id,
    spot_name: record.spot_name || record.name,
    alert_text: alertText,
    is_obs: isObs,
    observation_time: toIsoFromUtc(obsTime),
    sent_time: toIsoFromUtc(sentTime),
  };
}
